// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addWishList } from "@insite/client-framework/Services/WishListService";
import { chain, AddWishList } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
replaceInChain(chain, AddWishList, async props => {
    props.result = {};
    try {
        props.result.wishList =
            props.parameter.selectedWishList ??
            (await addWishList({ name: props.parameter.newListName, description: props.parameter.description }));
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        throw error;
    }
});
